import React from "react";
import StaticPage from "@/components/StaticPage";

export default function Terms() {
  return (
    <StaticPage eyebrow="Terms" title="Terms of Service">
      <p className="text-xs text-[#5C6B62]">Last updated: February 2026</p>

      <p>
        By creating a Tally account or using the app, you agree to these Terms. Please read them carefully.
      </p>

      <div>
        <div className="label-eyebrow mb-2">1. Not a medical device</div>
        <p>
          Tally provides AI-generated estimates of carbohydrate content for educational and informational purposes only. It is not a medical device and is not intended to diagnose, treat, or prevent any condition. Always consult a qualified healthcare professional before making changes to your medication, insulin dose, or diet based on information from Tally.
        </p>
      </div>

      <div>
        <div className="label-eyebrow mb-2">2. Account</div>
        <p>
          You are responsible for keeping your password safe and for activity that happens under your account. You must be at least 13 years old to use Tally.
        </p>
      </div>

      <div>
        <div className="label-eyebrow mb-2">3. Subscriptions and trials</div>
        <p>
          New accounts include a 7-day trial of Advanced features. After the trial, Advanced features require a paid subscription ($6.99 per 30-day period in test mode). Subscriptions do not auto-renew in the current version — when your access period ends, your account simply returns to the Free tier and you can renew manually.
        </p>
      </div>

      <div>
        <div className="label-eyebrow mb-2">4. Acceptable use</div>
        <ul className="list-disc pl-5 space-y-1">
          <li>Don&apos;t upload images that contain other people&apos;s personal information.</li>
          <li>Don&apos;t reverse-engineer, scrape, or abuse the service.</li>
          <li>Don&apos;t use Tally to give medical advice to others as if it came from a clinician.</li>
        </ul>
      </div>

      <div>
        <div className="label-eyebrow mb-2">5. Termination</div>
        <p>
          You can delete your account at any time from <strong>Profile → Delete Account</strong>. We may suspend an account that violates these Terms. After deletion, your data is permanently removed from our active database.
        </p>
      </div>

      <div>
        <div className="label-eyebrow mb-2">6. Liability</div>
        <p>
          Tally is provided &ldquo;as is&rdquo; without warranties of any kind. To the maximum extent permitted by law, Tally and its operators are not liable for any health decision made based on the app&apos;s estimates.
        </p>
      </div>

      <p>
        Questions about these Terms? Email{" "}
        <a className="text-[#1A2421] underline underline-offset-4" href="mailto:tallycarbcounter@gmail.com">
          tallycarbcounter@gmail.com
        </a>
        .
      </p>
    </StaticPage>
  );
}
